/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Audit_FilterInputs */



/**
* | output |
* | --- |
* | "Filter by user, action type, and date range" |
*
* @param {Plan_Gate_Benefit_Audit_FilterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_audit_filter = /** @type {((inputs?: Plan_Gate_Benefit_Audit_FilterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Audit_FilterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Filtern nach Benutzer, Aktionstyp und Zeitraum")
	return /** @type {LocalizedString} */ ("Filter by user, action type, and date range")
});